import lang from '@data/lang.json'
import utils from '@/utils/utils'


const ProductCard = {
  // Data
  data () {
    return {
      lang: lang.ProductCard
    }
  },
  // Props
  props: [
    'product'
  ],
  // Computed
  computed: {
    productPath: function() {
      if(this.product.Url && this.product.Url.length > 0) {
        return this.product.Url
      }
      else if (!this.product.UrlPath) {
        return ''
      } else {
        return utils.checkForSlashAtEnd(window.location.pathname) + utils.checkForSlashAtEnd(this.product.UrlPath)
      }
    }
  },
  // Methods
  methods: {
    price: function(item) {
      const fallbackPrice = !this.lang.FallbackPrice ? 'Kontakta oss' : this.lang.FallbackPrice

      if (!item.Price) {
        return fallbackPrice
      }

      const prefix = !item.Price.Prefix || item.Price.Prefix === "" ? '' : item.Price.Prefix

      const printPrice = !item.Price.PrintPrice || item.Price.PrintPrice === "" ? '' : item.Price.PrintPrice

      const suffix = (!printPrice || printPrice === "" )
        ? ''
        : !item.Price.Suffix || item.Price.Suffix === ""
          ? this.lang.PriceSuffix
          : item.Price.Suffix

      let priceString = prefix + ' ' + printPrice + ' ' + suffix
      priceString = priceString.trim().length === 0 ? fallbackPrice : priceString

      return priceString
    },
  },
}

export default ProductCard
